<template>
  <div class="home">
    <div class="col s12 no-padding">
      <div class="row">
        <nav class="transparent no-box-shadow">
          <div class="nav-wrapper container">
            <a href="#/" class="brand-logo">
              <img :src="getLogoBrand($root.page)" class="responsive-img" alt="" :style="$root.page=='aviatur'?'height: 30px;':'height: 60px;'">
            </a>
            <ul id="nav-mobile" class="right hide-on-med-and-down">
              <li><a class="grey-text" href="#">Inicio</a></li>
              <li><a class="grey-text" href="#how">¿Como Funciona?</a></li>
              <li><a class="grey-text" href="#moreinfo">¿Que debo hacer?</a></li>
              <li><a class="grey-text" href="#register">Registrarme</a></li>
              <li><button class="btn btn-circle  modal-trigger" :class="'gradient-'+$root.page" href="#login">Iniciar Sesión</button></li>
            </ul>
          </div>
        </nav>
        <div class="row">
           <div id="init" class="row">
             <div class="container" style="margin-top:8%">
               <h3 class="header"><b>¿Tienes una agencia de viajes?</b></h3>
               <p class="grey-text">
                 En <span>{{$root.page}}</span> Ofrecemos a las agencias de viajes que esta en proceso de desarrollo,
                 <br>
                 la posibilidad de obtener su propio buscador en linea,
                 <br>
                 una herramienta de ventas personalizable de marca blanca,
                 <br>
                 en donde hacemos accesible para su agencia la forma de integrarte con octopus,
                 <br>
                 nosotros nos encargamos del funcionamiento tecnológico
                 <br>
                 para que su agencia solo se preocupe por seguir creciendo.
               </p>
               <a class="btn btn-circle" :class="'gradient-'+$root.page" href="#how">Dar el primer paso</a>
             </div>
           </div>
           <br><br><br><br><br><br><br><br><br><br>
           <section id="how" class="row">
             <div class="container">
               <div class="row">
                 <div class="col s12 m6 l8">
                   <i class="material-icons hide"><h1>mood</h1></i>
                   <h4><b>¿Como funciona?</b></h4>
                   <p>
                     Sabemos que muchas agencias pequeñas emergentes o medianas,
                     compran por octopus.com, y gestionan con sus clientes.
                     <br>
                     Ahora queremos premiar a nuestros mejores consolidadores de ventas, incluyendolos en la empresa,
                     de forma que tengan un espacio donde puedan comprar, llevar control de sus ventas, y más importante aún,
                     comisionar por su nivel de ventas.
                   </p>
                 </div>
               </div>
               <div class="row">
                 <div class="col s12">
                   <i class="col s1 center material-icons" style="line-height:2;font-size:2rem;">flight</i>
                   <p class="col s10">
                     El servicio de vuelos y ventas de tiquetes nacionales e internacionales
                     con comision de 1% compartida con octopus, si la aerolinea genera hover por metas de ventas tambíen
                     serán compartidas en comisión.
                   </p>
                 </div>
                 <div class="col s12">
                   <i class="col s1 center material-icons" style="line-height:2;font-size:2rem;">hotel</i>
                   <p class="col s10">
                     El servicio de hoteles nacionales e internacionales
                     con comision aproximada del 14% compartida con octopus,
                     todas las negociaciones de hoteles que octopus tenga directamente,
                     serán compartidas también con la agencias.
                   </p>
                 </div>
                 <div class="col s12">
                   <i class="col s1 center material-icons" style="line-height:2;font-size:2rem;">card_travel</i>
                   <p class="col s10">
                     El servicio de  paquetes nacionales e internacionales
                     con comision aproximada del 15%, las negociaciones de paquetes
                     que octopus tenga directamente, serán compartidas también
                     con la agencias sugeto a excepciones.
                   </p>
                 </div>
               </div>
               <br><br><br><br><br><br><br><br><br><br>
               <div class="row">
                 <div class="col s12 m6 l4">
                   <i class="material-icons hide"><h1>brush</h1></i>
                   <h4><b>Edite su pagina web</b></h4>
                   <p>
                     Una vez su cuenta sea confirmada podrá editar el diseño
                     de su marca blanca en nuestra herramienta, iniciando sesión
                     y utilizando la herramienta "Diseño de mi web"
                   </p>
                 </div>
                 <div class="col s12 m6 l8 no-padding">
                   <img src="./../assets/img/steps/editor.png" class="responsive-img z-depth-5" alt="marca blanca aviatur">
                 </div>
               </div>
               <div class="row">
                  <div class="col s12">
                    <i class="material-icons hide"><h1>build</h1></i>
                    <h4><b>Herramientas de edición</b></h4>
                    <table>
                      <thead>
                        <tr>
                          <th>Icono</th>
                          <th>Uso</th>
                          <th>Descripción</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td><i class="material-icons">photo_size_select_large</i></td>
                          <td>Editar icono</td>
                          <td>Le permite subir el icono de su empresa</td>
                        </tr>
                        <tr>
                          <td><i class="material-icons tooltipped center">burst_mode</i></td>
                          <td>Editar color</td>
                          <td>Elija la paleta de colores</td>
                        </tr>
                        <tr>
                          <td><i class="material-icons tooltipped center">visibility</i></td>
                          <td>Editar botones</td>
                          <td>Seleccione los botones según el servicio que preste</td>
                        </tr>
                        <tr>
                          <td><i class="material-icons tooltipped center">format_shapes</i></td>
                          <td>Editar información</td>
                          <td>Edite la información visible de su empresa</td>
                        </tr>
                        <tr>
                          <td><i class="material-icons">collections</i></td>
                          <td>Editar imagen de fondo</td>
                          <td>Tendra una paleta de imagenes disponible para usar de fondo en su pagina</td>
                        </tr>
                        <tr>
                          <td><i class="material-icons tooltipped center">save</i></td>
                          <td>Guardar</td>
                          <td>Guarda el trabajo realizado</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
               </div>
               <br><br><br><br><br><br><br><br><br><br>
             </div>
           </section>
           <section id="moreinfo" class="row">
             <div class="container">
               <div class="row">
                 <div class="col s12 m6 l8">
                   <h4><b>¿Que debo hacer?</b></h4>
                   <p>Siga los pasos.</p>
                 </div>
               </div>
               <div class="row">
                 <div class="col s12">
                   <i class="col s1 center material-icons" style="line-height:1.8;font-size:2rem;">looks_one</i>
                   <p class="col s10">
                     El primer paso es registrarse dando click en <a v-on:click="selectTab('register')">Registro</a>
                   </p>
                 </div>
                 <div class="col s12">
                   <i class="col s1 center material-icons" style="line-height:1.8;font-size:2rem;">looks_two</i>
                   <p class="col s10">
                     Para el segundo paso al correo con el que se registre llegara un email en el cual deberá confirmar su cuenta.
                   </p>
                 </div>
                 <div class="col s12">
                   <i class="col s1 center material-icons" style="line-height:1.8;font-size:2rem;">looks_3</i>
                   <p class="col s10">
                     Al correo con el que se registre llegara un correo
                     en el cual deberá confirmar su cuenta y asignar una contraseña de acceso.
                   </p>
                 </div>
                 <div class="col s12">
                   <i class="col s1 center material-icons" style="line-height:1.8;font-size:2rem;">looks_4</i>
                   <p class="col s10">
                     Una vez confirmada su cuenta, tendra acceso a la plataforma,
                     puede iniciar sesión dando click <a href="#login">aquí</a> ,
                     y podra ingresar a la herramienta "Diseño de mi web"
                     donde puede editar el diseño de su web.
                   </p>
                 </div>
               </div>
             </div>
             <br><br><br><br><br><br><br><br><br><br>
           </section>
           <div id="register" class="container">
             <div class="row">
               <div class="col s12 m6 l8">
                 <h4><b>Registro</b></h4>
               </div>
             </div>
             <div class="row">
               <form id="form-register" class="" v-on:submit.prevent="register">
                 <div class="input-field col s12">
                   <i class="material-icons prefix">email</i>
                   <input name="mail" id="mail" type="email" class="validate" required="" v-model="agency.mail">
                   <label for="mail">Email</label>
                   <span class="helper-text" data-error="Tu correo no es valido 😕" data-success="ok"></span>
                 </div>
                 <div class="input-field col s12">
                   <i class="material-icons prefix">location_city</i>
                   <input name="nit" id="nit" type="text" pattern="[0-9]{8,11}" class="validate" required="" v-model="agency.nit">
                   <label for="nit">Nit de la empresa</label>
                   <span class="helper-text" data-error="Tu Nit no es valido 😕" data-success="Tu Nit esta perfecto 😃"></span>
                 </div>
                 <div class="input-field col s12">
                   <i class="material-icons prefix">account_circle</i>
                   <input name="name" id="name" type="text" class="validate" required="" v-model="agency.agency">
                   <label for="name">Nombre de la empresa</label>
                   <span class="helper-text" data-error="Tu nombre no es valido 😕" data-success="Que buen nombre 😃"></span>
                 </div>
                 <div class="input-field col s12">
                   <i class="material-icons prefix">fingerprint</i>
                   <input name="document" id="document" type="text" pattern="[0-9]{7,11}" class="validate" required="" v-model="user.document">
                   <label for="document">Tu Cedula</label>
                   <span class="helper-text" data-error="Tu Cedula no es valido 😕" data-success="Tu Cedula esta perfecto 😃"></span>
                 </div>
                 <div class="input-field col s12">
                   <i class="material-icons prefix">mood</i>
                   <input name="username" id="username" type="text" class="validate" required="" v-model="user.name">
                   <label for="username">Tu Nombre</label>
                   <span class="helper-text" data-error="Tu nombre no es valido 😕" data-success="Que buen nombre 😃"></span>
                 </div>
                 <div class="col s12">
                   <label>Ciudad</label>
                   <select name="city" id="city" class="browser-default black-text" v-model="agency.country" required>
                     <option value="" disabled selected>Selecciona tu ciudad</option>
                     <option v-bind:value="index" v-bind:key="index" v-for="(city,index) in cities.list">{{city}}</option>
                   </select>
                 </div>
                 <div class="center hide">
                   <h5>Realiza esta sencilla suma, para verificar que no eres un robot.</h5>
                 </div>
                 <div class="input-field col s12 row center">
                   <input class="hide" type="submit" value="Send">
                   <button class="btn btn-circle"  :class="'gradient-'+$root.page" type="submit" name="action" v-show="!loader.register">
                     <i class="material-icons right">send</i>
                     Registrar
                   </button>
                   <div class="preloader-wrapper active" v-show="loader.register">
                      <div class="spinner-layer spinner-blue-only">
                        <div class="circle-clipper left">
                          <div class="circle"></div>
                        </div><div class="gap-patch">
                          <div class="circle"></div>
                        </div><div class="circle-clipper right">
                          <div class="circle"></div>
                        </div>
                      </div>
                    </div>
                 </div>
               </form>
             </div>
           </div>
         </div>
      </div>
      <!-- Modal Success -->
      <div id="success" class="modal modal-success">
        <div class="modal-content">
          <h4>Perfecto, su registro está listo 🤖</h4>
          <p>Ahora debe confirmar su cuenta dando click <router-link :to="'/confirmation/'+agency.nit">aquí</router-link> o revisando su correo.</p>
        </div>
        <div class="modal-footer">
          <a class="modal-close waves-effect waves-green btn-flat">ok</a>
        </div>
      </div>
      <!-- Modal Login -->
      <div id="login" class="modal modal-success">
        <div class="modal-content">
          <Login/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
import * as firebase from "firebase/app"
import Login from '../containers/Login'
export default {
  name: 'Home',
  components:{Login},
  data:function(){
    return {
      "agency":{},
      "user":{},
      "site":"https://agenciasenlinea.octopus.com.co",
      "cities":{
        "ref": firebase.database().ref('cities'),
        "list":["Bogotá","Medellín"]
      },
      "users":{
        "ref": firebase.database().ref('users'),
        "list": [],
        "exist":{
          "mail":false,
          "doc":false
        }
      },
      "agencies":{
        "ref": firebase.database().ref('agenciestest/'+this.$root.page),
        "list": [],
        "exist":false
      },
      "notifications":{
        "ref": firebase.database().ref('notifications')
      },
      "loader":{
        "register":false
      }
    }
  },
  beforeCreate:function(){},
  created:function() {
    this.getCitiesList()
    if (this.$root.page=='aviatur') {
      this.site = "https://agenciasenlinea.aviatur.com"
    }
    //console.log(this.$root.page);
  },
  mounted:function() {
    document.addEventListener('DOMContentLoaded', function() {
      M.Parallax.init(document.querySelectorAll('.parallax'))
      M.Tabs.init(document.querySelectorAll('.tabs'))
      M.Modal.init(document.querySelectorAll('.modal'))
    })
    //this.success()
  },
  updated:function() {
    M.Parallax.init(document.querySelectorAll('.parallax'))
    M.Tabs.init(document.querySelectorAll('.tabs'))
  },
  methods:{
    getLogoBrand(brand) {
      var images = require.context('../assets/img/logo/', false, /\.svg$/)
      return images('./' + brand + ".svg")
    },
    selectTab(tab){
      var instance = M.Tabs.getInstance(document.getElementById("tabs"))
      instance.select(tab)
    },
    getCitiesList:function() {
      this.cities.ref.once('value', (cities)=> {
        cities.forEach((city)=> {
          this.cities.list.push(city.val())
        })
      })
    },
    sendEmail:function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Accept", "application/json");
      var raw = JSON.stringify({
        "agency":this.$root.page,
        "nit":this.agency.nit,
        "name":this.agency.agency,
        "email":this.agency.mail
      });
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch("https://aviasupport.herokuapp.com/whitemark/sendmail", requestOptions)
        .then(response => {
          if (response=="ok") {
            this.upload.loader=false
            this.$root.messageService("toast", "Logo subido")
            this.upload.time = new Date().getTime()
          }
          if (response=="error" || response!="ok") {
            this.upload.loader=false
            this.$root.messageService("toast", "Logo no subido")
          }
        })
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
    },
    success:function () {
      this.$root.messageService('toast','Perfecto, su registrado está listo 🤖')
      var Modalelem = document.querySelector('.modal-success');
      var instance = M.Modal.init(Modalelem)
      instance.open()
    },
    register:function() {
      this.users.exist = false
      this.users.ref.orderByChild('mail').equalTo(this.agency.mail).once('value', async (userss) => {
        if (userss.exists()) {
          this.$root.messageService('toast', 'Lo sentimos, tu Email se encuetra registrado 🤖')
          this.users.exist = true
          console.log(this.users.exist)
        } else {
          await firebase.database().ref('users/' + this.user.document).once('value').then((snapshot) => {
            if (snapshot.exists()) {
              this.$root.messageService('toast', 'Lo sentimos, tu Cedula se encuetra registrado 🤖')
              this.users.exist = true
            } else {
              this.users.exist = false
            }
          })
        }
        if (this.users.exist == false) {
          this.user.agency = this.agency.nit
          this.user.mail = this.agency.mail
          this.user.city = this.agency.country
          // this.user.company = "aviatur"
          this.user.fRol = 5
          this.user.password = this.user.mail
          this.agency.date = Date()
          this.agency.user = this.user.document;
          firebase.database().ref('users/' + this.user.document)
          .set(this.user)
          .then(() => {
            this.agencies.ref.orderByChild('nit').equalTo(this.agency.nit).once('value', (agencies) => {
              //console.log(agencies.val())
              if (agencies.exists()) {
                this.$root.messageService('toast', 'Lo sentimos, tu Nit se encuetra registrado 🤖')
                this.agencies.exist = true
              } else {
                this.agencies.exist = false
              }
              if (this.agencies.exist == false) {
                this.agency.state = 1
                firebase.database().ref('agenciestest/'+this.$root.page+'/' + this.agency.nit)
                .set(this.agency)
                .then(() => {
                  this.success()
                  this.sendEmail()
                })
                .catch(function(error) {
                  console.log(error)
                  this.$root.messageService('toast', 'Algo salio mal, recarga la pagina por fa 🤖')
                })
              }
            })
          })
          .catch(function(error) {
            console.log(error)
            this.$root.messageService('toast', 'Algo salio mal, recarga la pagina por fa 🤖')
          })
        }
        console.log(this.users.exist)
      }).catch((error) => {
        console.error(error);
      })
    }
  },
}
</script>
